import { Component, Input } from "@angular/core";
import { LanguageService } from "../../services/language.service";
import { GanttTask } from "./task.model";

@Component({
  selector: "app-gantt",
  templateUrl: "./gantt.component.html",
  styleUrls: ["./gantt.component.css"]
})
export class GanttComponent {
  @Input() taskListWidth = 500;
  @Input() scaleType = "days";
  @Input() height: number;

  @Input() columns: any;
  @Input() tasks: GanttTask[];
  @Input() selectedRowKey: number;
  @Input() dependencies: any;
  @Input() resources: any;
  @Input() resourceAssignments: any;

  constructor(public languageService: LanguageService) {}
}
